module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/appqrcode.2646c369.png";